































import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import {
    QueryPharmacyStockWarning
} from '../../../api/pharmacy'
//单据打印组件
import print from '../../../components/print/stockBills.vue'

@Component({
    components:{print}
})
export default class IndateWarning extends AbpBase {
	//名称检索
	@Watch('pharmacyName')
	WatchpharmacyName(val: string, oldVal: string) { 
		this.table.currentPage = 1
		this.getData()
	}

	printShow:Boolean = false;
    printData = {
        list:[],
        title:[
            '药品名称',
            '生产厂家',
            '规格型号',
            '数量/库存',
            '基本单位',
            '零价',
            '库存警戒',
        ]
	}


	pharmacyName = ''//名称检索
	list = []//table数据源

	table = {
		loading:false,
		totalCount : 0,
		pageSize : 10,
		currentPage:1
	}
	
	created(){
		this.getData()
    }
    //数据导出
    exportData(){
        (this.$refs.table as any).exportCsv({
            filename: 'The original data'
        })
    }
    print(){
		this.printData.list = []
		this.list.forEach((item,index)=>{
			this.printData.list.push([
				item.drugName,
				item.place,
				item.model,
				item.quantity,
				item.basicUnitName,
				item.priceAmount,
				item.stockWarn
			])
		})
		this.printShow = true
	}
	//打印完成回调
    printBack(){
        this.printShow = false;
	}
	
	async getData(){
		this.table.loading = true
		let payload = {
			queryString:this.pharmacyName,
			pageSize:this.table.pageSize,
			page:this.table.currentPage
		}
		let response = await QueryPharmacyStockWarning(payload)
		this.list = response.data.items
	
		this.table.totalCount = response.data.totalCount
		this.table.loading = false
	}
	pageChange(page: number) {
		this.table.currentPage = page
		this.getData()
	}
	columns = [{
		type: 'add.vue',
		title: this.L('OwnCoding'),
	},{
		title: "药品名称",
		key: 'drugName'
	},{
		title: "生产厂家",
		key: 'place'
	},{
		title: "规格型号",
		key: 'model'
	},{
		title: "数量/库存",
		key:'quantity'
    },{
		title: "基本单位",
		key: 'basicUnitName'
	},{
		title: "零价",
		key:'priceAmount'
    },{
		title: "库存警戒",
		key:'stockWarn'
    }
    ]
	
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pharmacy/repertoryWarning/index.vue